<mb-accelerator #accelerator color="notification">
    <mb-icon icon="info"></mb-icon>
        <mb-accelerator-title>
            @if (occupancy < 85) {
                <span i18n="@@few-offer__date-high-request">El destino está siendo muy solicitado para las fechas que estás buscando</span>
            } @else {
                <span i18n="@@few-offer__date-low-availability">Ya hay poca disponibilidad en el destino para las fechas que estás buscando</span>
            }
        </mb-accelerator-title>
        <mb-accelerator-description>
            @if (occupancy < 85) {
                <span i18n="@@few-offer__book-accommodation-asap">¡Reservá tu alojamiento cuanto antes!</span>
            } @else {
                <span i18n="@@few-offer__book-before-out">¡Reservá antes que se agote!</span>
            }
        </mb-accelerator-description>
</mb-accelerator>
